import { Component, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { environment } from 'environments/environment';
import { T2CardComponent } from './trip2-theme/components/t2-card/t2-card.component';

declare const jQuery: any;
declare const Push: any;
declare const Parse: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  title = 'app works!';
  changeRoute: boolean;
  @ViewChild('modalReloadApp') modalReloadApp: T2CardComponent;
  private tenantConfig: { [key: string]: { [key: string]: string } } = {
    'safety.trip2.com': { isSafety: 'true' },
    'dhp.trip2.com': { isDHP: 'true', isDHPAuth: 'true' },
    'medcare.trip2.com': { isDHP: 'true', isMedCare: 'true', isDHPAuth: 'false' },
    'devtenant.trip2.com': {
      isDHP: 'true',
      isMedCare: 'true',
      isDHPAuth: 'false'
    },
    'hs.trip2.com': { isHs: 'true' },
    'webclm.trip2.com': { isCLM: 'true' },
    'clm.trip2.com': { isCLM: 'true' },
    'webapp.trip2.com': { isWebApp: 'true' },
    'dev.trip2.com': { isWebApp: 'true' },
    'beta.trip2.com': { isWebApp: 'true' },
    'mbmg.trip2.com': { isMBMG: 'true' },
    'av.trip2.com': { isAV: 'true' },
    'localhost': { isWebApp: 'true' }
  };

  private possibleKeys: string[] = [
    'isSafety',
    'isDHP',
    'isDHPAuth',
    'isMedCare',
    'isHs',
    'isCLM',
    'isWebApp',
    'isMBMG',
    'isAV',
  ];
  constructor (
    router: Router
  ) {
    router.events
    .subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.changeRoute = false;
      }
      if (event instanceof NavigationStart) {
        this.changeRoute = true;
      }
    });
  }

  ngOnInit(): void {
    const hostname = window.location.hostname;
    this.configureLocalStorage(hostname);
  }

  realoadApp(): void {
    window.location.reload();
  }

  pushMessageVersion(localVersion, serverVersion): void {
    try {
      Push.create('Important announcement', {
        body: 'Your current version is different from the server version, please reload the application.',
        icon: 'assets/images/logo.png',
        requireInteraction: true,
        tag: '#version',
        onClick: function () {
          window.focus();
          this.close();
        }
      });
    } catch (error) {
    }
  }

  verifyVersion(value) {
    window.localStorage.setItem('localVersion', environment.version);
    window.localStorage.setItem('remoteVersion', value.get('version'));
    try {
      if (environment.production) {
        if (
          value.get('version') !== environment.version &&
          value.get('app') === environment.parse.models.versions.name_row
        ) {
          this.pushMessageVersion(environment.version, value.get('version'));
        }
      }
    } catch (error) {
    }
  }

  configureLocalStorage(hostname: string): void {
    if (this.possibleKeys && this.possibleKeys.length) {
      this.possibleKeys.forEach((key) => localStorage.removeItem(key));
      const config = this.tenantConfig[hostname];
      if (config) {
        Object.keys(config).forEach((key) => {
          localStorage.setItem(key, String(config[key]));
        });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts